import ConditionalToolTip from "components/design/conditionalToolTip";
import ToolTip from "components/design/toolTip";

export const StateRegistrations = ({
  registedStates,
}: {
  registedStates: { state_name: string; uuid: string }[];
}) => {
  const isMultipleStates = registedStates.length > 1;

  if (registedStates.length === 0) {
    return "-";
  }

  return (
    <ConditionalToolTip
      condition={
        registedStates.length > 1 && (
          <div>
            {registedStates.slice(1).map((state) => (
              <div key={state.uuid} className="t-text-surface">
                {state.state_name}{" "}
              </div>
            ))}
          </div>
        )
      }
    >
      <div className="t-text-body-sm t-text-neutral-70 t-w-fit t-max-w-full">
        {registedStates[0].state_name}{" "}
        {isMultipleStates && <span>+{registedStates.length - 1}</span>}
      </div>
    </ConditionalToolTip>
  );
};
